- description:
    en: |
      Systems with physical multiple moving agents will be more and more common,
      e.g., automated warehouse, delivery service with robots, self-driving cars,
      etc. Obviously, such systems should be well-coordinated, but in general, coordination/cooperation
      themselves are ambiguous and intractable, such as societies of ants and bees.
      Therefore, I believe that multiple moving agents have a lot of applications
      that we cannot imagine right now. My research questions are twofold: 1) explore
      the potential of multiple moving agents, 2) characterize cooperative behavior
      of moving agents.
    ja: |
      人体を必要とした作業が機械群に置き換えられてゆく過渡期にあたって,
      移動エージェント群を自由自在に操るための研究は高度なオートメーション化の根幹をなす.
      基幹となる技術は, 経路計画アルゴリズムや計画の実行ポリシー,
      マルチロボットシステムのプラットフォーム等である.
      分散的な環境で動く, 適応的かつスケーラブルな実現方法を追求し,
      将来, SFのように自律ロボット群に市街で躍動してもらうことを目指す.
  gif:
    - src: mapf
      title:
        en: multi-agent path finding
        ja: マルチエージェント経路計画
    - src: reloc
      title:
        en: deadlock-free execution
        ja: デッドロックフリーな計画実行
    - src: 10drones
      title:
        en: drone swarm control
        ja: ドローン群の制御
  title:
    en: Intelligent Collective Behavior Design for Swarm Agents
    ja: 自律エージェント群の制御
